import React from 'react';
import Floater from 'react-floater-fixed';

import { withTheme, ThemeProps } from 'styled-components';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { InfoArea, CloseButton, Overlay } from './styles';

interface Props extends ThemeProps<any> {
  content: React.ReactNode;
  target: string;
  noCloseBtn?: boolean;
  onClose: (e: React.SyntheticEvent) => void;
}

const Tooltip = ({ content, target, theme, noCloseBtn, onClose }: Props) => {
  const { t } = useStoreTranslation();

  const floaterCustomStyles = {
    arrow: {
      color: theme.joyRide.background,
    },
    container: {
      borderRadius: 16,
      background: theme.joyRide.background,
    },
    floater: {
      maxWidth: '95%',
    },
  };

  const floaterContent = () => (
    <InfoArea>
      <img src="/images/advice.svg" alt="inf" />
      {content}
      {!noCloseBtn && <CloseButton onClick={onClose}>{t('tooltip.close')}</CloseButton>}
    </InfoArea>
  );

  return (
    <>
      <Floater
        autoOpen
        disableAnimation
        placement="bottom"
        styles={floaterCustomStyles}
        content={floaterContent()}
        target={`#${target}`}
      />
      <Overlay onClick={onClose} />
    </>
  );
};

export default withTheme(Tooltip);
